var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42383 12.8058V6.20579L13.5526 3.24496C16.3942 1.60412 21.4817 5.65121 19.3459 9.35454",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42383 9.59761L14.1392 6.29761L19.268 9.25844C22.1097 10.8993 21.1472 17.3297 16.8709 17.3297",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2017 7.99335L16.9171 11.2933V17.2196C16.9171 20.5013 10.8671 22.8846 8.73126 19.1813",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9788 9.71655V16.1974L8.85003 19.1582C6.00836 20.7991 0.920863 16.752 3.0567 13.0486",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9789 12.8058L8.26349 16.1058L3.13474 13.145C0.288492 11.4996 1.25099 5.07373 5.52724 5.07373",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2017 14.41L5.48624 11.11V5.18377C5.48624 1.9021 11.5362 -0.481231 13.6721 3.2221",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenaiLogo);
export default __webpack_public_path__ + "static/media/openai-logo.dccf7313fa6548e650d08f17380bdec6.svg";
export { ForwardRef as ReactComponent };